module.exports = __webpack_public_path__ + "static/img/user-03.c2b089b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-03.png
// module id = Gz4G
// module chunks = 1